import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Subscription } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useSubscription = (
  projectId: string,
  topicName: string,
  subscriptionId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Subscription>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Subscription>({
    queryKey: ["projects", projectId, "topics", topicName, "subscriptions", subscriptionId],
    queryFn: async (): Promise<Subscription> => {
      const response = await api.get<Subscription>(
        `/projects/${projectId}/topics/${encodeURIComponent(topicName)}/subscriptions/${subscriptionId}`
      );
      return camelize(response.data);
    },
    ...options
  });
};
